import { useEffect } from 'react';
import { getOrCreateGtag, getTrackingWindow } from '../util/inject-head-script';

interface GoogleConsentProps {
    /**
     * When set, Google Consent Mode is defaulted to denied for every ad and
     * analytics storage and data signal.
     */
    denySharingConsent: boolean;
}

/**
 * Declares the Google Consent Mode default for every Google tag on the page.
 *
 * Rendered ahead of GA4 and Google Ads, and unconditionally, because the
 * default is only respected if it reaches gtag before the first `config`. It is
 * separate from those tags rather than a prop on one of them so the guarantee
 * does not depend on which of them happens to be configured.
 *
 * Denied does not mean nothing is measured: GA4 keeps reporting in a cookieless
 * form, so first-party aggregate measurement survives while storing or sharing
 * personal data for advertising stops.
 */
export const GoogleConsentHead: React.FC<GoogleConsentProps> = ({
    denySharingConsent,
}) => {
    useEffect(() => {
        if (!denySharingConsent) {
            return;
        }

        getOrCreateGtag(getTrackingWindow())('consent', 'default', {
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            analytics_storage: 'denied',
        });
    }, [denySharingConsent]);

    return null;
};
